// extracted by mini-css-extract-plugin
module.exports = {"deliveryForm":"VdI8l","button":"s8oJf","disabled":"AcjXT"};